module.exports = __webpack_public_path__ + "img/2.1.b1dd1094.jpg";